
const IconFacebook = ({fill= "#3A559F", width="40", height="40", className=""}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : null}
      data-name="IconFacebook"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 11V29C3 33.4183 6.58172 37 11 37H21.1071V23.8665H16.6807V18.505H21.1071V14.0023C21.1071 10.7277 23.7617 8.07312 27.0363 8.07312H31.6638V12.8943H28.3526C27.3121 12.8943 26.4685 13.7378 26.4685 14.7783V18.5051H31.5806L30.8741 23.8666H26.4685V37H29C33.4183 37 37 33.4183 37 29V11C37 6.58172 33.4183 3 29 3H11C6.58172 3 3 6.58172 3 11Z"
        fill={fill}
      />
    </svg>
  );
};
export default IconFacebook;
